<template>
  <span
    :class="`AiChips AiChips--${variant}`"
    :aria-label="$t('accessibility.description.cardTag')">
    <ai-icon v-if="accessoryLeft" :name="accessoryLeft" />
    <ai-typo
      as="span"
      :class="`AiChips-label AiChips-label--${variant}`"
      :color="color"
      variant="overline-02">
      {{ label }}
    </ai-typo>
    <ai-icon
      v-if="accessoryRight"
      class="AiChips-icon"
      :name="accessoryRight" />
  </span>
</template>

<script lang="ts" setup>
import AiIcon from '../AiIcon/AiIcon.vue';
import AiTypo from '../AiTypo/AiTypo.vue';
import type { IconName } from '../AiIcon/types';
import type { TypoColor } from '../AiTypo/types';

export interface AiChipsProps {
  accessoryLeft?: IconName;
  accessoryRight?: IconName;
  label: string;
  variant?: 'positive' | 'inverse';
  color?: TypoColor;
}

withDefaults(defineProps<AiChipsProps>(), {
  accessoryLeft: undefined,
  accessoryRight: undefined,
  variant: 'positive',
  color: undefined,
});
</script>
<style scoped lang="scss">
@use '@/assets/styles/utilities/mixins';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.AiChips {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: constants.$margin-01;

  margin: 0;
  padding: constants.$inner-01 constants.$inner-03;

  background: colors.$gold-200;
  white-space: nowrap;

  @include mixins.rem-fallback(height, 24);
  @include mixins.rem-fallback(border-radius, 100);

  &--inverse {
    background: colors.$stratos-900;
  }

  &-label {
    text-transform: uppercase;
    &--inverse {
      color: colors.$gold-300;
    }
  }
}
</style>
